// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"35c9e377","513":"3b859a03","703":"2ebc478c","787":"d5a7c410"}[chunkId] + ".chunk.js";
};